// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".floating-button[data-v-5b5f11c8]{position:fixed;bottom:32px;right:32px;transform:translateY(96px);transition:all .25s ease-in-out;opacity:0;z-index:10}.floating-button[data-v-5b5f11c8]:hover{border-radius:64px}.floating-button--show[data-v-5b5f11c8]{transform:translateY(0);opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
